module.exports = "/images/avatar-s-20.jpg?e8861d8caf03a6a986fd7a498fb18d87";